import React from 'react';

import { DescriptionList, DescriptionItem } from '@gogame/components';

const GgLinkExpirationDate = ({ data }) => {
  return (
    <DescriptionList disableGutters data={data}>
      <DescriptionItem
        type={'date'}
        field={'ggLinksExpirationDate'}
        label={'Expiration Date'}
        template={'LL'}
        timeZone={'utc'}
      />
    </DescriptionList>
  );
};

export default GgLinkExpirationDate;
